import React, { useEffect, useState } from "react";
import { IDbTasksState } from "../../redux/reducers/tasks.slice";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { Box, BoxProps, Checkbox, Divider, FormControlLabel, ListItemText } from "@mui/material";
import { ICompany, ICompanyGroup } from "bets.oddprovider.lib.common.ts/models";
import { DEFAULTGAP } from "../../globals";

interface ICompanySelectable extends ICompany {
  selected: boolean
}

interface ICompanyGroupSelectable extends ICompanyGroup {
  selected: boolean
}

const DbTasksDatabasesItemComponent = (props: {
  company: Partial<ICompanySelectable>,
  onToggle: (checked: boolean, dbName: string | undefined) => void
}) => {
  // console.log(`DbTasksDatabasesItemComponent.constructor: ${props.company.name}`)

  return <>
    <FormControlLabel
      id={`DbTasksDatabasesItemComponent_${props.company.id}`}
      control={<Checkbox
        checked={props.company.selected ?? false}
        onChange={(e) => {
          if (props.onToggle)
            props.onToggle(e.target.checked, props.company.database_name)
        }}
      />}
      label={<ListItemText primary={props.company.name} secondary={props.company.database_name} secondaryTypographyProps={{
        style: {
          fontSize: 12
        }
      }} />} />
  </>
}

const DbTasksDatabasesGroupComponent = (props: {
  companyGroup: Partial<ICompanyGroupSelectable>,
  onChange: (companyGroup: Partial<ICompanyGroupSelectable>) => void
}) => {
  const [visible, setVisible] = useState(false)
  // console.log(`DbTasksDatabasesGroupComponent.constructor: ${props.companyGroup.name}`)

  return <div id={`DbTasksDatabasesGroupComponent_${props.companyGroup.id}`}>
    {/* <FormControlLabel
      control={<Checkbox
        checked={props.companyGroup?.selected ?? false}
        onChange={(e) => {
          let result = {
            ...props.companyGroup,
            selected: e.target.checked,
            companies: [
              ...(props.companyGroup?.companies?.map(c => ({
                ...c,
                company: {
                  ...c.company,
                  selected: e.target.checked
                } as ICompanySelectable
              })) ?? [])
            ]
          } as ICompanyGroupSelectable

          if (props.onChange)
            props.onChange(result)
        }}
      />}
      label={props.companyGroup?.name}
    /> */}

    <Checkbox
      checked={props.companyGroup?.selected ?? false}
      onChange={(e) => {
        let result = {
          ...props.companyGroup,
          selected: e.target.checked,
          companies: [
            ...(props.companyGroup?.companies?.map(c => ({
              ...c,
              company: {
                ...c.company,
                selected: e.target.checked
              } as ICompanySelectable
            })) ?? [])
          ]
        } as ICompanyGroupSelectable

        if (props.onChange)
          props.onChange(result)
      }}
    />
    <label style={{cursor: 'pointer'}} onClick={() => setVisible(!visible)}>{props.companyGroup.name}</label>

    {visible ? <Box id={`DbTasksDatabasesGroupComponent_Box_${props.companyGroup.id}`} sx={{
      display: 'flex',
      flexDirection: { xs: 'row', md: 'column' },
      flexWrap: 'wrap',
      marginLeft: 4
    }}>
      {props.companyGroup?.companies?.map((c, idx) => c.company ? <DbTasksDatabasesItemComponent
        key={idx}
        onToggle={(checked: boolean, dbName: string | undefined) => {
          let result = {
            ...props.companyGroup,
            selected: checked ? (props.companyGroup?.companies?.map(c => c.company).filter(c => !(c as ICompanySelectable)?.selected && c?.database_name != dbName).length ? props.companyGroup?.selected : true) : false,
            companies: [
              ...(props.companyGroup?.companies?.map(c => ({
                ...c,
                company: {
                  ...c.company,
                  selected: c.company?.database_name == dbName ? checked : (c.company as ICompanySelectable).selected
                } as ICompanySelectable
              })) ?? [])
            ]
          } as ICompanyGroupSelectable

          if (props.onChange)
            props.onChange(result)
        }}
        company={c.company}
      /> : <></>)}
    </Box> : <></>}
  </div>
}

export interface DbTasksDatabasesComponentProps extends BoxProps {
  onGetDbSelected: (dbNames: string[]) => void
}

export const DbTasksDatabasesComponent: React.FC<DbTasksDatabasesComponentProps> = ({ onGetDbSelected, ...props }) => {
  // console.log('DbTasksDatabasesComponent.constructor')

  const tasksState: IDbTasksState = useSelector((state: RootState) => state.tasksState)
  const [companiesGroups, setCompaniesGroups] = useState<Partial<ICompanyGroupSelectable>[] | undefined>()

  useEffect(() => {
    setCompaniesGroups(tasksState.companiesGroups)
  }, [tasksState.companiesGroups])

  function getSelectedCompanyDatabases(companyGroups: Partial<ICompanyGroupSelectable>[]): string[] {
    const databaseNames = new Set<string>(); // Utilizamos Set para evitar duplicatas

    companyGroups
      .map(group => group?.companies ?? []) // Mapeia os arrays de companies ou retorna vazio se undefined
      .reduce((acc, companies) => acc.concat(companies), []) // Achata o array de arrays em um único array
      .filter(companyGroup => (companyGroup.company as Partial<ICompanySelectable>).selected) // Filtra onde o company está definido e selected = true
      .forEach(companyGroup => databaseNames.add(companyGroup.company!.database_name)); // Adiciona ao Set

    return Array.from(databaseNames); // Converte o Set para array
  }

  return <>
    <Box
      {...props}
      id={props.id ?? 'DbTasksDatabasesComponent'}
      style={{
        minWidth: 250,
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        padding: `${DEFAULTGAP}px ${DEFAULTGAP}px ${DEFAULTGAP}px ${DEFAULTGAP / 2}px`,
        ...props.style,
      }}
    >
      {companiesGroups?.map((cg, idx) => <DbTasksDatabasesGroupComponent
        key={idx}
        companyGroup={cg}
        onChange={(companyGroup: Partial<ICompanyGroupSelectable>) => {
          const companies: Partial<ICompanySelectable>[] = companyGroup.companies?.map(c => c.company as Partial<ICompanySelectable>) ?? []

          let tmp = [
            ...(companiesGroups?.map(cg => cg.id == companyGroup.id ? {
              ...companyGroup
            } : {
              ...cg,
              companies: [
                ...(cg.companies?.map(c => companies.filter(_ => _.database_name == c.company?.database_name).length ? {
                  ...c,
                  company: {
                    ...c.company,
                    selected: companies.filter(_ => _.database_name == c.company?.database_name)[0].selected
                  } as Partial<ICompanySelectable>
                } : c) ?? [])
              ]
            } as Partial<ICompanyGroupSelectable>) ?? []),
          ]

          tmp = [
            ...tmp.map(c => ({
              ...c,
              selected: !c.companies?.filter(c => !(c.company as Partial<ICompanySelectable>).selected).length
            } as Partial<ICompanySelectable>))
          ]

          setCompaniesGroups(tmp)
          if (onGetDbSelected)
            onGetDbSelected(getSelectedCompanyDatabases(tmp ?? []))
        }}
      />)}
    </Box>
  </>
}